import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@Component({
    selector: 'app-search-bar',
    templateUrl: './search-bar.component.html',
    styleUrls: ['./search-bar.component.css'],
    imports: [ReactiveFormsModule, FormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchBarComponent {

  @Input() placeholder = 'Search';
  @Input() filterParameter = '';
  @Output() filterParameterChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() searchEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() resetFilterEvent: EventEmitter<void> = new EventEmitter<void>();

  search() {
    this.searchEvent.emit();
    this.filterParameterChange.emit(this.filterParameter);
  }

  resetFilter() {
    this.filterParameter = '';
    this.resetFilterEvent.emit();
    this.filterParameterChange.emit(this.filterParameter);
  }
}
